// extracted by mini-css-extract-plugin
export default {"shimmer":"shimmer_shimmer__pbzPH","skeletonShimmer":"shimmer_skeletonShimmer__9lqox"};